import React, { useEffect, useState, useMemo, useCallback } from 'react';
import DataListInput from 'react-datalist-input';
import PathManagement from '../../common/path-management';
import { searchSuggestions } from '../../common/entities/search';
import { withRouter } from 'react-router-dom';
import debounce from 'lodash.debounce';
import { searchRoute } from '../../common/constants'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

function Search(props) {
  const [SearchDataItems, setSearchDataItems] = useState(null);
  const [SearchedItem, setSearchedItem] = useState(null);
  const [InputValue, setInputValue] = useState(null);
  const [InputValueForOptionMatch, setInputValueForOptionMatch] = useState(null);
  const [DebounceTime, setDebounceTime] = useState(2000);
  const arraytest = ['uno', 'dos', 'tres'];
  const [ActivateDatalist, setActivateDatalist] = useState(false);
  const [DictionaryAvailability, setDictionaryAvailability] = useState(true)
  const [IsWriting, setIsWriting] = useState(false)

  useEffect(() => {
    //setDebounceTimer()
  }, [InputValueForOptionMatch]);
  useEffect(() => {
    if (InputValueForOptionMatch) {
      redirectOnOptionMatch();
    }
  }, [InputValueForOptionMatch]);

  /**
   * @param {string} key
   */



  useEffect(()=>{
    if(IsWriting===false && InputValue){
      getAPIData(InputValue)
    }
  },[IsWriting])


  //DESCOMENTAR EL GETAPIDATA PARA EL DICCIONARIO EN EL BUSCADOR  ----------------------------------------------------

  const onSearchChange = (key) => {
    setIsWriting(true)
    setInputValue(key);
    setTimeout(
      function () {
        // getAPIData(key);
        setIsWriting(false)
      }, 2000);
    // setInputValue(key);
    // getAPIData(key);
  };

  const changing = () => {
    // getAPIData(InputValue)
    // console.log(InputValue)
    setIsWriting(false)
  }

  var timer;
  const change = () => {
    clearTimeout(timer);
    timer = setTimeout(changing, 2000);
  }

  // console.log(SearchDataItems)

  const getAPIData = async (key) => {
    const res = await searchSuggestions(key);
    setSearchDataItems(res);
    // let _search = new SearchData();
    // let _res = await _search.getSearchData(url);
    // setSearchDataItems(_res)
  };
  const redirect = (toWhere) => {
    props.history.push('/search/' + toWhere);
  };


  const getDataListOptions = () => {
    if (SearchDataItems && SearchDataItems[0] && SearchDataItems[0].key) {
      return SearchDataItems.map((data, i) => {
        return <div><option id='datalist-option' value={data.key}>{data.key}</option></div>;
      });
    }
  };

  const redirectToItem = (e) => {
    let item = e.currentTarget.parentElement.parentElement.children[1].value;
    if(item){
    setSearchedItem(item);
    redirect(item);
    setActivateDatalist(false)
    }
  };

  const handleKeyDown = (e) => {
    let item = e.currentTarget.value;
    if (e.key === 'Enter') {
      redirect(item);
    }
  };

  const changeHandler = (event) => {
    setInputValueForOptionMatch(event.target.value);
    setActivateDatalist(true)
  };

  const redirectOnOptionMatch = () => {
    if (SearchDataItems && SearchDataItems[0] && SearchDataItems[0].key) {

      // redirect(InputValueForOptionMatch);

    }
  };

  const debouncedChangeHandler = useCallback(debounce(changeHandler, DebounceTime), []);

  const setDebounceTimer = () => {
    let inputValue = document.getElementById('searchInput').value;
    let matches = 1;
    // setInputValueForOptionMatch(inputValue)

    if (SearchDataItems && SearchDataItems[0] && SearchDataItems[0].key) {
      SearchDataItems.map((data, i) => {
        if (data.key === inputValue) {
          setDebounceTime(2000);
        }
        if (data.key !== inputValue) {
          matches = matches + 1;
          if (matches === SearchDataItems.length) {
            setDebounceTime(3000);
          }
        }
      });
    }
  };

  return (
    // <form className="input-group" >
    <div className="input-group">
      <span className="input-group-btn">
        <button onClick={redirectToItem}>
          <i className="icon-search" />
        </button>
      </span>
      <input
        className="form-control"
        type="search"
        placeholder="Busca productos, marcas y más..."
        id="searchInput"
        list="searchDataList"
        onChange={(e) => {
          setIsWriting(true)
          setDictionaryAvailability(true)
          const key = e.target.value;
          onSearchChange(key)
          change();
          debouncedChangeHandler(e);
        }}

        onKeyUp={handleKeyDown}
      />
      <datalist id="searchDataList">
        {InputValue && InputValue.length > 2 ? getDataListOptions() : null}
      </datalist>

      {/* // </form> */}
    </div>
  );
}
export default withRouter(Search);
